import { useShowMore } from "../../../hooks/useShowMore";
import { StaggeredContainer, StaggeredItem } from "../../animations/staggeredFadeIn";
import {
    BoldText,
    ButtonDiv,
    CruiseSubHeader,
    CruiseWrapper,
    Description,
    ListItem,
    ShowMoreButton,
    ShowMoreContent,
    StyledList,
} from "../styled";
import { useTranslation } from "react-i18next";

const Bikes = () => {
    const { t } = useTranslation("bikes");
    const { showAll, handleToggle, buttonRef } = useShowMore();

    const offerItems = t("sections.offer.items", { returnObjects: true });
    const gondolaItems = t("sections.gondola.items", { returnObjects: true });
    const audienceItems = t("sections.audience.items", { returnObjects: true });

    const renderList = (items) => (
        <StyledList>
            {items.map((item, idx) => (
                <ListItem key={idx}>
                    <BoldText>{item.label} </BoldText>
                    {item.text}
                </ListItem>
            ))}
        </StyledList>
    );

    return (
        <CruiseWrapper>
            <StaggeredContainer>
                <ShowMoreContent $isVisible={showAll}>
                    <StaggeredItem>
                        <CruiseSubHeader>{t("sections.offer.title")}</CruiseSubHeader>
                    </StaggeredItem>
                    <StaggeredItem>
                        <Description>{t("sections.offer.intro")}</Description>
                    </StaggeredItem>
                    <StaggeredItem>{renderList(offerItems)}</StaggeredItem>
                    <StaggeredItem>
                        <Description>{t("sections.offer.outro")}</Description>
                    </StaggeredItem>

                    <StaggeredItem>
                        <CruiseSubHeader>{t("sections.gondola.title")}</CruiseSubHeader>
                    </StaggeredItem>
                    <StaggeredItem>
                        <Description>
                            {t("sections.gondola.introParts.beforeBold")}
                            <BoldText>{t("sections.gondola.introParts.bold")}</BoldText>
                            {t("sections.gondola.introParts.afterBold")}
                        </Description>
                    </StaggeredItem>
                    <StaggeredItem>{renderList(gondolaItems)}</StaggeredItem>

                    <StaggeredItem>
                        <CruiseSubHeader>{t("sections.audience.title")}</CruiseSubHeader>
                    </StaggeredItem>
                    <StaggeredItem>
                        <Description>{t("sections.audience.intro")}</Description>
                    </StaggeredItem>
                    <StaggeredItem>{renderList(audienceItems)}</StaggeredItem>
                    <StaggeredItem>
                        <Description>
                            <BoldText>{t("sections.audience.finalParts.bold")}</BoldText>{" "}
                            {t("sections.audience.finalParts.text")}
                        </Description>
                    </StaggeredItem>
                </ShowMoreContent>

                <ButtonDiv>
                    <ShowMoreButton onClick={handleToggle} ref={buttonRef}>
                        {showAll ? t("toggle.hide") : t("toggle.show")}
                    </ShowMoreButton>
                </ButtonDiv>
            </StaggeredContainer>
        </CruiseWrapper>
    );
};

export default Bikes;